import { render, staticRenderFns } from "./QuizList.vue?vue&type=template&id=4ba02edc&scoped=true"
import script from "./QuizList.vue?vue&type=script&lang=js"
export * from "./QuizList.vue?vue&type=script&lang=js"
import style0 from "./QuizList.vue?vue&type=style&index=0&id=4ba02edc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba02edc",
  null
  
)

export default component.exports